import { Tooltip, Chip } from '@mui/material';
import { formatters, ValueInput } from '@utils/formattersV2';
import { MISSING_VALUE, NO_CONFIDENCE_LEVEL } from '@constants/stats';

type ConfidenceLevelProps = {
  value: ValueInput;
  lift: ValueInput;
};

export const ConfidenceLevel = ({ value, lift }: ConfidenceLevelProps) => {
  if (value === null || value === undefined) return null;

  const formatted = formatters.confidenceLevel(value, lift);

  const isSpecialCase =
    formatted === NO_CONFIDENCE_LEVEL || formatted === MISSING_VALUE;

  const chipLabel = isSpecialCase ? formatted : `${formatted} CL`;

  const tooltipTitle = isSpecialCase
    ? 'No Confidence Level'
    : `${formatted} Confidence Level`;

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <Chip
        label={chipLabel}
        size="small"
        sx={{
          width: 70,
        }}
      />
    </Tooltip>
  );
};
